import axios from "axios";

const api = axios.create({ baseURL: process.env.VUE_APP_BASE_URL });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("auth_token");
            localStorage.removeItem("user_id");
            if (window.location.pathname !== "/auth/signin") {
                const back = window.location.pathname + window.location.search;
                window.location.href = "/auth/signin?redirect=" + encodeURIComponent(back);
            }
        }
        return Promise.reject(error);
    }
);

export default api;
